import {  BASE_URL_PARSER } from '../constants/index';

export const parseCatalogue = async (ENDPOINT_URL, requestData) => {
  try {
    if (!ENDPOINT_URL) return null;
    const response = await fetch(`${BASE_URL_PARSER}${ENDPOINT_URL}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
    });
    const data = await response.json();
    if (response.ok) {
      return { success: true, data: data }  ;
    } else {
      return { success: false, data: null };
    }
  } catch (error) {
    console.error('Error in POST request:', error);
    return { success: false, data: null, error };
  }
};